export default __webpack_public_path__ + "static/media/csv-upload.8e3f74c8.svg";